import { UserProfile } from "../../data/userProfile";
import { cdnGetRequest } from "../../utils/webrequests";

export async function getPublicProfiles(): Promise<UserProfile[]>{
    const data:UserProfile[] = await cdnGetRequest("cdn-data/publicprofiles.json");
    return data;
};